import { css, keyframes, SerializedStyles } from "@emotion/react";
import { useTheme } from "basis";

const TRANSITION_DURATION = "0.2s";

const loading = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export function useStyles() {
  const theme = useTheme();
  const styles = {
    root: {
      alignItems: "center",
      display: "flex",
      gap: theme.space[4],
      position: "relative",
      justifyContent: "space-between",
      width: "100%",
      minWidth: 0,
    },
    button: {
      position: "relative",
      width: "80px",
      height: "36px",
      lineHeight: 1,
      verticalAlign: "middle",
      backgroundColor: theme.colors.grey.t65,
      border: 0,
      borderRadius: "100px",
      cursor: "pointer",
      userSelect: "none",
      "&:focus:not(:active)": {
        outline: "none",
        backgroundColor: theme.colors.grey.t65,
        // eslint-disable-next-line no-underscore-dangle
        ...theme.focusStyles.__keyboardFocus,
      },
      // Checked State
      '&[aria-checked="true"]': {
        backgroundColor: theme.colors.highlight.blue.t100,
        "&:focus:not(:active)": {
          backgroundColor: theme.colors.primary.blue.t100,
        },
      },
      // Disabled State
      "&:disabled": {
        cursor: "no-drop",
        opacity: 0.6,
      },
    },
    handle: {
      position: "absolute",
      width: "34px",
      height: "34px",
      left: "1px",
      top: "1px",
      backgroundColor: theme.colors.white,
      borderRadius: "36px",
      transition: `all ${TRANSITION_DURATION} ease-in-out`,
      zIndex: 1,
      pointerEvents: "none",
      'button[aria-checked="true"] + &': {
        left: "45px",
      },
      // Hover State
      "button:hover:not(:disabled) + &": {
        boxShadow: "rgb(0 70 170 / 25%) 0px 0px 0px 8px",
      },
    },
    loading: {
      margin: "8px auto",
      textIndent: "-9999em",
      width: "20px",
      height: "20px",
      border: `3px solid ${theme.colors.primary.blue.t100}`,
      borderTop: `3px solid ${theme.colors.white}`,
      borderRadius: "50%",
      animation: `${loading} 1s infinite linear`,
      transform: "translateZ(0)",
    },
    text: {
      color: theme.colors.white,
      display: "flex",
      flexDirection: "row-reverse",
      fontFamily: theme.fonts.heading,
      fontSize: theme.fontSizes[0],
      fontWeight: theme.fontWeights.bold,
      justifySelf: "flex-start",
      padding: `0 ${theme.space[1]}`,
      textTransform: "uppercase",
      'button[aria-checked="true"] &': {
        flexDirection: "row",
      },
    },
  };
  return Object.keys(styles).reduce((acc, key) => {
    acc[key] = css(styles[key]);
    return acc;
  }, {}) as Record<string, SerializedStyles>;
}
